export default __webpack_public_path__ + "static/media/safari.89cec5de.png";